import axios from "../../utils/axios";
import {ADD_BOOK, DELETE_BOOK, SET_BOOKS, UPDATE_BOOK} from "./actionTypes";
import {toast} from "react-toastify";
import {setErrors} from "./error";

export const getBooks = (warehouseId = null) => dispatch => {
  const endpoint = warehouseId ? `booked-dock/?warehouse=${warehouseId}` : 'booked-dock/';

  axios
      .get(`${endpoint}&show_all`)
      .then(response => dispatch(setBooks(response.data.results)))
      .catch(console.log);
};

export const setBooks = payload => ({
  type: SET_BOOKS,
  payload
});

export const addBook = (body, closeModal) => async dispatch => {
  try {
    const res = await axios.post('booked-dock/', body);
    dispatch({
      type: ADD_BOOK,
      payload: res.data
    });
    toast.success('Successfully Added.', {
      position: toast.POSITION.TOP_RIGHT,
      className: ''
    });
    closeModal();
  } catch (e) {
    dispatch(setErrors(e.response.data));
  }
};

export const updateBook = (body, closeModal) => async dispatch => {
  try {
    const response = await axios.post(`booked-dock-change/`, body);
    dispatch({
      type: UPDATE_BOOK,
      payload: response.data.result
    });
    toast.success('Successfully Requested.', {
      position: toast.POSITION.TOP_RIGHT,
      className: ''
    });
    closeModal();
  } catch (e) {
    dispatch(setErrors(e.response.data));
  }
};

export const cancelBook = (id, closeModal) => async dispatch => {
  try {
    await axios.delete(`booked-dock/${id}/`);
    dispatch({
      type: DELETE_BOOK,
      payload: id
    });
    toast.success('Successfully canceled.', {
      position: toast.POSITION.TOP_RIGHT,
      className: ''
    });
    closeModal();
  } catch (e) {
    console.log(e);
  }
};


// WEBPACK FOOTER //
// ./src/store/actions/book.js